import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_edit",
  "use": "icon-icon_edit-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"icon-icon_edit\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h36v36H0z\" /><path d=\"m25.136 4.5-3 3H7.5v21h21V13.864l3-3V30a1.5 1.5 0 0 1-1.5 1.5H6A1.5 1.5 0 0 1 4.5 30V6A1.5 1.5 0 0 1 6 4.5h19.136Zm5.591-1.35 2.123 2.124-13.788 13.788-2.118.005-.003-2.126L30.728 3.15Z\" fill=\"#999\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol